import '../css/license.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import ProgressBar from './ProgressBar';
import React, { useEffect, useState, useRef } from 'react';
import { Loading } from '../components/loading.js';
import { Turl } from '../components/tUrl.js'
import { AiOutlineSync } from 'react-icons/ai';

const tg = window.Telegram ? window.Telegram.WebApp : null;

function License({ recData, handlesetIndex }) {
    const [mData, setmData] = useState(null);
    const [noTrade, setNoTrade] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    const toggleActUpd = () => {
        setmData(false);
    };

    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }


                if (userData) {
                    const response = await fetch(Turl + '/st/license', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    console.log(rd);
                    setmData(rd)

                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
            setNoTrade(null)
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;

    // --- Список активных лицензий пользователя ---
    const userLicList = recData.user_lic.map((element, index) => (
        <div className='l-sub-block' key={index}>
            <div className="l-data-row">
                <div className="l-data-label" style={{ width: "auto" }}>{element.name}  {recData.trade_balance < 50 ? '(PAUSE)' : ''}</div>
                <div className="l-data-value">
                    {formatNumberWithCommas(element.profit, 2)} / {formatNumberWithCommas(element.price, 0)} USDT
                </div>
            </div>
            <ProgressBar
                completed={recData.trade_balance < 50 ? 100 : ((element.profit) / element.price) * 100}
                bgColor="#2196f3" // Вы можете изменить этот цвет
                height="10px"
            />
        </div>
    ));

    // --- Список всех доступных лицензий (из mData) ---
    const allLicList = mData.data.map((element, index) => (
        <div className='l-data-row' key={index}>
            <div className='l-data-label'>{element.name}</div>
            <div className='l-data-value1 l-value-center'>{element.count} (<span >{parseInt(element.count_24h)}</span>)</div>
            <div className='l-data-value2 '>(<span style={{ color: '#4cdf4c' }}>{formatNumberWithCommas((parseFloat(element.tamount)/parseFloat(element.count))/(element.price/100), 2)}%</span>) {formatNumberWithCommas(parseFloat(element.tamount), 2)} USDT</div>
        </div>
    ));

    const lic_pools = mData.data.reduce((acc, item) => acc + parseFloat(item.tamount), 0);

    // --- Блок "License Pool" ---
    const stat = (
        <div className='l-main-block'>
            {/* Главная строка "License pool" */}
            <div className='l-data-row l-pool-header'>
                <div className='l-data-label'>{t`License pool`}</div>
                <div className='l-data-value1 l-value-center'>
                    <button style={{ display: "flex" }} className="menu-button" onClick={() => { toggleActUpd(); }} >
                        <AiOutlineSync />
                    </button>
                </div>
                <div className='l-data-value2 ' style={{ color: '#4cdf4c' }}>
                    {formatNumberWithCommas(lic_pools, 0)} USDT
                </div>
            </div>
            {/* Список всех лицензий */}
            {allLicList}
        </div>
    );

    // --- Кнопка "Buy" ---
    const buy = (
        <>
            <button className="l-action-button" onClick={() => { if (recData.trade_balance >= 50) { handlesetIndex(31) } else { setNoTrade(true) } }}>
                {t`Buy license`}
            </button>
            {noTrade ? <div>{t`To purchase, you need to start trading from 50 USDT`}</div> : <></>}
        </>
    );

    // --- Блок "Active License" ---
    const bal = (
        <div className='l-main-block'>
            <div className='l-data-row l-active-header'>
                <div className='l-data-label'>{t`Active License:`}</div>
                <div className='l-data-value'>
                    {recData.user_lic.length === 0 ? t`No` : ""}
                </div>
            </div>
            {userLicList}
        </div>
    );

    return <>{stat} {buy} {bal}</>
}

export { License };